import React, { useState } from 'react'
import PropTypes from 'prop-types'
import RegionTable from './regions-table'
import RegionForm from './region-form'
import FlashAlert from '../flash-alert'

function Regions({regions, countries, states, currencies, onCreate, onUpdate, onDelete}) {
  const [showForm, setShowForm] = useState(false)
  const [alert, setAlert] = useState(null)

  const crteateRegion = (data) => {
    setShowForm(false)
    onCreate(data)
  }

  const updateRegion = (data) => {
    setShowForm(false)
    onUpdate(data)
  }

  const deleteRegion = (data) => {
    setShowForm(false)
    onDelete(data)
  }

  return <div className='wrapper'>
    { alert && <FlashAlert text={alert.text} type={alert.type} centred onHide={() => setAlert(null)} />}

    { showForm && 
      <RegionForm
        regionData={showForm}
        countries={countries}
        states={states}
        currencies={currencies}
        onClose={() => setShowForm(false)}
        onCreate={crteateRegion}
        onUpdate={updateRegion}
        onDelete={deleteRegion}
      />
    }
    <h2>Regions</h2>
    <RegionTable regions={regions} onEdit={(data) => setShowForm(data)} />
    <button className='btn btn-primary' onClick={() => setShowForm({})}>+ New Region</button>
  </div>
}

Regions.propTypes = {
  regions: PropTypes.array.isRequired,
  countries: PropTypes.array.isRequired,
  states: PropTypes.object.isRequired,
  currencies: PropTypes.array.isRequired,
  onCreate: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
}

export default Regions
